import type { RouteObject } from 'react-router';

import { Suspense } from 'react';
import { Outlet } from 'react-router';

import lazyWithReload from 'src/utils/lazyWithReload';

import { CONFIG } from 'src/global-config';
import { DashboardLayout } from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

import { AuthGuard } from 'src/auth/guard';

import { usePathname } from '../../../routes/hooks';

// ----------------------------------------------------------------------
const CampaignListPage = lazyWithReload(() => import('src/pages/campaign/list'));
const CampaignStepPage = lazyWithReload(() => import('src/pages/campaign/step'));
const CampaignDetailPage = lazyWithReload(() => import('src/pages/campaign/detail'));

// ----------------------------------------------------------------------

function SuspenseOutlet() {
  const pathname = usePathname();
  return (
    <Suspense key={pathname} fallback={<LoadingScreen />}>
      <Outlet />
    </Suspense>
  );
}

const dashboardLayout = () => (
  <DashboardLayout>
    <SuspenseOutlet />
  </DashboardLayout>
);

export const campaignRoutes: RouteObject[] = [
  {
    path: 'campaign',
    element: CONFIG.auth.skip ? dashboardLayout() : <AuthGuard>{dashboardLayout()}</AuthGuard>,
    children: [
      { index: true, element: <CampaignListPage /> },
      { path: 'step', element: <CampaignStepPage /> },
      { path: ':id/details', element: <CampaignDetailPage /> },
    ],
  },
];
